import {useEffect, useState} from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import {Skeleton, Stack} from '@mui/material';
import {useTranslation} from "react-i18next";

am4core.useTheme(am4themes_animated);

const ChartFive = ({ data, name, className }) => {
    const [showLoader, setShowLoader] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        // Create chart instance
        let chart = am4core.create(name, am4charts.XYChart);

        chart.events.on('ready', () => {
            setShowLoader(false);
        });

        chart.data = data['data'];
        let legendData = data['legend'];

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.minGridDistance = 50;

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.extraMax = 0.15; // Add extra space on the right side
        valueAxis.title.text = t('LOCAL_INDICATORS.IN_ALL_PEOPLE');

        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.valueY = "local_expenditures_per_person";
        series.dataFields.dateX = "year";
        series.strokeWidth = 2;
        series.name = legendData['local_expenditures_per_person'];
        series.tooltipText = "{name}: [bold]{valueY}[/]";
        series.tensionX = 0.8;
        series.showOnInit = true;

        let bullet = series.bullets.push(new am4charts.Bullet());
        bullet.width = 12;
        bullet.height = 12;
        bullet.horizontalCenter = "middle";
        bullet.verticalCenter = "middle";

        let rectangle = bullet.createChild(am4core.Rectangle);
        rectangle.strokeWidth = 2;
        rectangle.direction = "top";
        rectangle.width = 12;
        rectangle.height = 12;

        // add label
        let label = series.bullets.push(new am4charts.LabelBullet());
        label.label.text = "{valueY}";
        label.label.dy = -20;

        // Add cursor
        chart.cursor = new am4charts.XYCursor();

    }, []);

    return (
        <>
            <div style={{ display: 'flex', gap: '20px' }} >
                {/* Chart container */}
                <div id={name} style={{width: showLoader ? '0' : '100%', height: showLoader ? '0' : '700px'}} className={className}></div>
            </div>

            {showLoader && (
                <Stack spacing={1}>
                <Skeleton variant='text' />
                    <Skeleton variant='rounded' width={'auto'} height={500} />
                </Stack>
            )}
        </>
    );
};

export default ChartFive;


